import React from "react";
import { Navigate, Route } from "react-router-dom";

export const StudentPrivateRoute = ({ element, ...rest }) => {
  const token = localStorage.getItem("token"); // Check if token exists in localStorage

  // If no token, redirect to the login page
  return token ? element : <Navigate to="/login" />;
};

export const LoginPrivateRoute = ({ element, ...rest }) => {
  const token = localStorage.getItem("token"); // Check if token exists in localStorage

  // If no token, redirect to the portal page
  return token ? element : <Navigate to="/portal" />;
};
